import React from "react";
import Modal from "react-modal";
import { Button, Message, Serial, Title, Detail } from "./style";

const CompleteIssue = ({ onClose, isopen, serial }) => {
  const customStyles = {
    overlay: {
      position: "fixed",
      inset: "0px",
      zIndex: 2,
      background: "transparent",
    },
    content: {
      top: "60%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      background: "rgb(255 255 255 / 85%)",
      borderRadius: "2vw",
      border: "none",
      display: "flex",
      width: "60%",
      flexDirection: "column",
      alignItems: "center",
    },
  };
  Modal.setAppElement("body");
  return (
    <Modal isOpen={isopen} style={customStyles} contentLabel="Example Modal">
      <Message>
        <Title>¡Su caso ha sido radicado Exitosamente!</Title>
        <Detail>
          Por favor guarde o anote el siguiente número para hacer seguimiento de
          su caso:
        </Detail>
      </Message>
      <Serial>{serial}</Serial>
      <Button onClick={onClose}>Listo</Button>
    </Modal>
  );
};

export default CompleteIssue;
